<template>
	<div id="PagePlace">
		<div class="container content-place">

			<div class="row">
				<div class="col-12">

					<div class="wrapper-headlines-with-buttons">
						<div class="row justify-content-center">
							<div class="col-md-12 col-lg-auto">
								<h1 class="d-inline-block">{{ $t('Select the location') }}</h1>
							</div>
							<div class="col-xs-12 col-sm-auto">
								<div class="btn-group">
									<Dropdown
										:disabled="!stations_by_city"
										:buttonclass="'btn-light'"
										:buttontext="'City'"

										v-model="active_city"
										@onChange="setCity"

										:items="dropdown_cities"
									></Dropdown>
								</div>
							</div>
							<div class="col-xs-12 col-sm-auto">
								<div class="btn-group">
									<Dropdown
										:disabled="!stations_by_city"
										:buttonclass="'btn-light'"
										:buttontext="'Station'"

										v-model="active_station"
										@onChange="setStation"

										:items="dropdown_stations"
									></Dropdown>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>

		<div class="container container-map">
			<div class="row no-gutters">
				<div class="col-12 text-center">
					<div class="rounded-corners wrapper-rounded-content">
						<GmapMap
							ref="map"

							class="google-maps"
							:center="center"
							:zoom="initZoom"
							style="min-height: 420px;"
							>
								<GmapMarker
									v-if="geolocation"

									:icon="'/static/img/google_maps_position_ball.png'"
									:position="geolocation"
									:clickable="true"
									@click="center=geolocation"
								/>
								<GmapCluster
								:key="'st-'+index" v-for="(st, index) in stations_by_city"
								>
									<GmapMarker
										:key="index"
										v-for="(m, index) in st"

										:icon="(active_station === m.station ? '//mt.googleapis.com/vt/icon/name=icons/spotlight/spotlight-waypoint-a.png' : '//mt.googleapis.com/vt/icon/name=icons/spotlight/spotlight-poi.png')"
										:position="makePosition(m.position)"
										:clickable="true"
										@click="handleClickMapMarker(m)"
									/>
								</GmapCluster>
						</GmapMap>
					</div>

				</div>
			</div>
		</div>

		<div class="container content-place">
			<div class="row">
				<div class="col-12 text-center col-cta-button" v-bind:class="active_station ? 'visi' : 'invisi'">
					<router-link :to="{name: 'PageTime', params: { station: station.station }}">
						<button type="button" class="btn btn-primary btn-wp">
							{{ $t('Continue to time selection') }}
						</button>
					</router-link>
				</div>
			</div>

		</div>
	</div>
</template>

<script>

import { mapGetters } from 'vuex'

import forEach from 'lodash/forEach';
import sortedIndexBy from 'lodash/sortedIndexBy';

// https://stackoverflow.com/questions/17746740/google-map-icons-with-visualrefresh

export default {
	name: 'PagePlace',
	data(){
		return {
			active_city: false,
			active_city_store: false,
			active_station: false,
			stations_by_city: false,
			initZoom: 14,
			geolocation: false,
			center: {
				lat: 51.1693351,
				lng: 9.9777854
			}
		}
	},
	computed: {
		// map core functions
	    ...mapGetters('orm', [
	      'stations'
	    ]),
	    ...mapGetters('orm/reservation', [
	      'station'
	    ]),

	    dropdown_cities(){
	    	var out = [];
	    	if(!this.stations_by_city) return out;

	    	forEach(this.stations_by_city, (stations, cityname) => {
	    		out.push(cityname);
	    	});

	    	return out;
	    },
	    dropdown_stations(){
	    	var cityname = this.active_city;
	    	var out = [];
	    	if(!this.stations_by_city) return out;
	    	var stations = this.stations;
	    	if(this.stations_by_city[cityname]) stations = this.stations_by_city[cityname];

	    	forEach(stations, (station) => {
	    		out.push({value: station.station, label: (station.street ? station.street : station.name)});
	    	});

	    	return out;
	    },
	},

	created(){
		var self = this;
	},
	mounted() {
		const self = this;
		this.$store.commit('core/SET_LOADING', 'gmap');
		this.$store.dispatch('orm/GET_STATIONS_BY_CITY')
		.then(cities => {
			self.stations_by_city = cities;
			self.$refs.map.$mapPromise
			.then(self.geolocate)
			.then(map => {
				this.$store.commit('core/UNSET_LOADING', 'gmap');

				self.$store.dispatch('orm/GET_GROUPS') // preload groups
				.catch(err => { this.$store.commit("core/ADD_ERROR", err); });
				self.$store.dispatch('orm/GET_STATIONS_BY_DISTANCE', self.center)
				.then(stations => {
					if(this.station.station){
						this.setStation(this.station.station);
					}
					if(stations){
						var first = stations[Object.keys(stations)[0]];
						if(first){
							this.bounceToLatLng([first.position, self.center]);
						}
					}
				}).catch(err => { this.$store.commit("core/ADD_ERROR", err); })

				if(this.$store.getters['orm/station'](this.$route.params.stationid)){
					self.setStation(this.$route.params.stationid);
				}
			});

		}).catch(err => { this.$store.commit("core/ADD_ERROR", err); })
	},
	methods: {
		setCity(e){
			if(typeof this.stations_by_city[e] === 'undefined') return;

			if(this.active_city_store === e) return;



			var latLngs = [];
			forEach(this.stations_by_city[e], (station, index) => {
				latLngs.push(station.position);
			});

			this.bounceToLatLng(latLngs, 0.1);
			this.active_city_store = e;
			this.active_station = false;
		},

		setStation(e){
			this.active_station = e;
			this.$store.commit('orm/reservation/SET_STATION', e);

			var station = this.$store.getters['orm/reservation/startstation'];
			var latLngs = [station.position];
			this.bounceToLatLng(latLngs, 0.005, true);

			var city = this.$store.getters['orm/reservation/startstation'].city;
			if(this.active_city !== city){
				this.active_city = city;
			}
		},

		handleClickMapCluster(e) {
			console.log('handleClickMapCluster', e, this, e.target);
		},

		handleClickMapMarker(station) {
			this.active_station = station.station;

			this.$store.commit('orm/reservation/SET_STATION', station.station);


			var latLngs = [this.$store.getters['orm/reservation/startstation'].position];
			this.bounceToLatLng(latLngs, 0.001, true);

			if(this.active_city !== station.city){
				this.active_city = station.city;
			}
		},

	    geolocate: function() {
	    	var self = this;
			navigator.geolocation.getCurrentPosition(position => {
				const pos = {
					lat: position.coords.latitude,
					lng: position.coords.longitude
				};

				self.center = pos;
				self.geolocation = pos;
			});
	    },

	    bounceToLatLng(latLngs, padding, animated){
	    	if(typeof padding === 'undefined') padding = 0.02;

			var self = this,
				bounds = new google.maps.LatLngBounds();

			forEach(latLngs, (latlng, index) => {
				bounds.extend(self.makePosition(latlng));
			});

			// Don't zoom in too far on only one marker
		    if (bounds.getNorthEast().equals(bounds.getSouthWest())) {
		    	var nelat = Number(bounds.getNorthEast().lat().toFixed(4));
		    	var nelng = Number(bounds.getNorthEast().lng().toFixed(4));

				var extendPoint1 = new google.maps.LatLng(nelat + padding, nelng + padding);
				var extendPoint2 = new google.maps.LatLng(nelat - padding, nelng - padding);
				bounds.extend(extendPoint1);
				bounds.extend(extendPoint2);
		    }


		    this.$refs.map.$mapPromise.then((map) => {
				map.fitBounds(bounds);
		    })
	    },

		makePosition(obj, obj2){
			let lat, lng;
			if(typeof obj === 'object' && obj.lat) lat = obj.lat;
			if(typeof obj === 'object' && obj.lng) lng = obj.lng;
			if(typeof obj === 'object' && obj.long) lng = obj.long;
			if(obj && typeof obj == 'number') lat = lat;
			if(obj2 && typeof obj2 == 'number') lng = obj2;

			lat = parseFloat(lat);
			lng = parseFloat(lng);

			if(lat && lng && window.google && new google.maps.LatLng){
				return new google.maps.LatLng(lat, lng);
			} else if(lat && lng){
				return {lat,lng};
			}

			return false;
		},
	}

}
</script>



// WEBPACK FOOTER //
// src/components/Pages/PagePlace.vue